import UserReducer from '../../reducers/UserReducer'
import { DELETE, GET, PATCH, POST, makeQueryString, makeQueryStringFromObject } from '../apiHelper'
import { requestWithPromise } from '../index'

export const getAllSectors = (user, paramaters = {}) => {
  return requestWithPromise(`/api/sectors${makeQueryString(paramaters)}`, GET, null, user)
}

export const getSectorDocuments = (user, sector) => {
  return requestWithPromise(
    `/api/sectors/${sector.id}/documents`,
    GET,
    null,
    user
  )
}

export const getPlaces = (sector, user, parameters = {}) => {
  return requestWithPromise(
    `/quota/sectors/${sector.id}${makeQueryStringFromObject(parameters)}`,
    GET,
    null,
    user
  )
}

export const fetchSectorScore = (user, sector, endDate, startDate, additionalData) => {
  return requestWithPromise(
    `/sector/${sector.id}/evaluation-internships/score?end-date=${endDate}&start-date=${startDate}&additional-data=${additionalData}`,
    GET,
    null,
    user
  ).then(json => {
    return json?.data ?? {}
  })
}

export const getSectorPresets = (user, sector) => {
  return requestWithPromise(
    `/api/sectors/${sector.id}/shift-presets`,
    GET,
    null,
    user
  )
}

export const getInternshipsBySector = (user, sector) => {
  return requestWithPromise(
    `/api/sectors/${sector.id}/internships`,
    GET,
    null,
    user
  )
}

export const createSector = (user, sector) => {
  return requestWithPromise(
    '/api/sector',
    POST,
    sector.toRequestBody(),
    user
  )
}

/** @deprecated 2024-06-06 */
export const createSectorOld = (user, sector) => {
  return requestWithPromise(
    '/api/Sector',
    POST,
    sector,
    user
  )
}

export const updateSector = (user, sector) => {
  return requestWithPromise(
    `/api/sector/${sector.id}`,
    PATCH,
    sector.toRequestBody(),
    user
  )
}

/** @deprecated 2024-06-06 */
export const updateSectorOld = (user, sector, body) => {
  return requestWithPromise(
    `/api/Sector/${sector.id}`,
    PATCH,
    body,
    user
  )
}

export const archiveSector = (user, sector, archive = true) => {
  return requestWithPromise(
    `/sector/archive/${sector.id}`,
    PATCH,
    { toArchive: archive },
    user
  )
}

export const deleteSector = (user, sector) => {
  return requestWithPromise(
    `/api/sector/${sector.id}`,
    DELETE,
    null,
    UserReducer
  )
}

export const switchSectorInstitution = (user, sector, institution) => {
  return requestWithPromise(
    `/sectors/${sector.id}/transfer`,
    PATCH,
    { targetInstitution: institution.id },
    user
  )
}

export const assignManagedBy = (user, sector, idsManagedBy) => {
  return requestWithPromise(
    `/api/sectors/${sector.id}/users`,
    PATCH,
    { users: idsManagedBy },
    user
  )
}
